module.exports = __webpack_public_path__ + "img/LandingPage_ECC.2c51582a.png";